import { SelectOption } from '@/types/form.type.ts';

export enum CarAdmissionType {
    HyundaiMobility = 'hyundai_mobility',
    Dealer = 'dealer',
}

export function getCarAdmissionTypeLabel(type: CarAdmissionType): string {
    switch (type) {
        case CarAdmissionType.HyundaiMobility:
            return 'Хендэ Мотор СНГ';
        case CarAdmissionType.Dealer:
            return 'Дилерский';
    }
}

export function getCarAdmissionTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarAdmissionType).forEach((type: CarAdmissionType) => {
        options.push({
            label: getCarAdmissionTypeLabel(type),
            value: type,
        });
    });

    return options;
}
